'use client';

import { c as _c } from "react/compiler-runtime";
import { login } from '@/app/login/action';
import { PasswordField } from '@/components/FormInput/PasswordField';
import { Alert, Button, Card, CardContent, CircularProgress, Link, TextField } from '@mui/material';
import NextLink from 'next/link';
import type { FC } from 'react';
import { useActionState, useState } from 'react';
export const LoginForm: FC<{
  redirectTo: string;
}> = t0 => {
  const $ = _c(28);
  const {
    redirectTo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loginState, loginFormAction, loginPending] = useActionState(login, t1);
  let t2;
  if ($[1] !== loginState.formData) {
    t2 = loginState.formData?.get("email") as string ?? "";
    $[1] = loginState.formData;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [email, setEmail] = useState(t2);
  const forgotPasswordHref = email ? `/auth/forgot-password?email=${encodeURIComponent(email)}` : "/auth/forgot-password";
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      maxWidth: 400,
      width: "100%"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== redirectTo) {
    t5 = <input type="hidden" name="redirectTo" value={redirectTo} />;
    $[5] = redirectTo;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setEmail(e.target.value);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== email) {
    t7 = <TextField id="email" name="email" type="email" label="Email" placeholder="m@example.com" required={true} fullWidth={true} autoFocus={true} value={email} onChange={t6} />;
    $[8] = email;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PasswordField id="password" name="password" label="Password" required={true} fullWidth={true} slotProps={{
      htmlInput: {
        "data-testid": "login-password"
      }
    }} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== loginPending) {
    t9 = loginPending ? <CircularProgress size={20} color="inherit" /> : null;
    $[11] = loginPending;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = loginPending ? "Logging in..." : "Login";
  let t11;
  if ($[13] !== loginPending || $[14] !== t10 || $[15] !== t9) {
    t11 = <Button type="submit" disabled={loginPending} variant="contained" fullWidth={true} startIcon={t9}>{t10}</Button>;
    $[13] = loginPending;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      fontSize: "0.875rem",
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        textDecoration: "underline"
      },
      "&:focus": {
        textDecoration: "underline"
      }
    };
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== forgotPasswordHref) {
    t13 = <Link component={NextLink} href={forgotPasswordHref} prefetch={false} sx={t12}>Forgot your password?</Link>;
    $[18] = forgotPasswordHref;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== loginState.error) {
    t14 = loginState.error && <Alert severity="error">Invalid credentials. Try again, or click the forgot password link above.</Alert>;
    $[20] = loginState.error;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t13 || $[24] !== t14 || $[25] !== t5 || $[26] !== t7) {
    t15 = <Card sx={t3}><CardContent component="form" action={loginFormAction} sx={t4}>{t5}{t7}{t8}{t11}{t13}{t14}</CardContent></Card>;
    $[22] = t11;
    $[23] = t13;
    $[24] = t14;
    $[25] = t5;
    $[26] = t7;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};